import { useMediaQuery } from '@mui/material';
import { DESKTOP_CONTENTS_MAX_WIDTH } from '@/app/stylesguides';

const useCheckisSmallerBaseDeskTopSize = () => {
  const isSmallerBaseDeskTopSize = useMediaQuery(`(max-width:${DESKTOP_CONTENTS_MAX_WIDTH + 20 * 2}px)`);
  return isSmallerBaseDeskTopSize;
};

export default useCheckisSmallerBaseDeskTopSize;
